// Türkçe alfabetik sıralama yardımcıları. Sunucuda `companies.name_1` /
// `users.username_1` indeksleri olduğu için o sorgulara MongoDB collation
// eklenmedi (IXSCAN'ı COLLSCAN'a düşürüyordu); sıra burada düzeltilir.
export const trCompare = (a, b) =>
  String(a ?? "").localeCompare(String(b ?? ""), "tr");

export const sortByNameTr = (list, key = "name") =>
  [...(Array.isArray(list) ? list : [])].sort((x, y) => trCompare(x?.[key], y?.[key]));
